<div>
    <h1>Rate Testing</h1>
    <form [formGroup]="my_form">
        <mat-form-field>
            <mat-label>Rate Type</mat-label>
            <mat-select formControlName="rate_method">
                <mat-option *ngFor="let method of rate_methods; let i = index" [value]="i+1">
                    {{method}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div>
            <h3>Origin Location</h3>
            <mat-form-field>
                <mat-label>Data Type</mat-label>
                <mat-select formControlName="origin_type">
                    <mat-option *ngFor="let type of location_types" [value]="type">
                        {{type.replace('_', ' ')}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="my_form.get('origin_type')?.value === 'CITY_STATE'">
                <mat-label>City</mat-label>
                <input matInput formControlName="origin_city"/>
            </mat-form-field>
            <mat-form-field *ngIf="my_form.get('origin_type')?.value === 'CITY_STATE'">
                <mat-label>Province/State</mat-label>
                <input matInput formControlName="origin_state" maxlength="2">
            </mat-form-field>
            <mat-form-field *ngIf="my_form.get('origin_type')?.value === 'POSTAL_CODE'">
                <mat-label>Postal/Zip Code</mat-label>
                <input matInput formControlName="origin_postal" maxlength="6">
            </mat-form-field>
        </div>
        <div>
            <h3>Destination Location</h3>
            <mat-form-field>
                <mat-label>Data Type</mat-label>
                <mat-select formControlName="destination_type">
                    <mat-option *ngFor="let type of location_types" [value]="type">
                        {{type.replace('_', ' ')}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="my_form.get('destination_type')?.value === 'CITY_STATE'">
                <mat-label>City</mat-label>
                <input matInput formControlName="destination_city"/>
            </mat-form-field>
            <mat-form-field *ngIf="my_form.get('destination_type')?.value === 'CITY_STATE'">
                <mat-label>Province/State</mat-label>
                <input matInput formControlName="destination" maxlength="2">
            </mat-form-field>
            <mat-form-field *ngIf="my_form.get('destination_type')?.value === 'POSTAL_CODE'">
                <mat-label>Postal/Zip Code</mat-label>
                <input matInput formControlName="destination_postal" maxlength="6">
            </mat-form-field>
        </div>
    </form>
    <form [formGroup]="shipment_form">
        <div>
            <h3>Packages</h3>
            <div formArrayName="packages">
                <div *ngFor="let package of packages.controls; let i = index" [formGroupName]="i">
                    <mat-form-field>
                        <mat-label>Weight</mat-label>
                        <input matInput formControlName="weight">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Height</mat-label>
                        <input matInput formControlName="height">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Length</mat-label>
                        <input matInput formControlName="length">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Width</mat-label>
                        <input matInput formControlName="width">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Stack Height</mat-label>
                        <input matInput formControlName="stack_height" type="number">
                    </mat-form-field>
                    <button mat-raised-button (click)="removePackage(i)">Remove Package</button>
                </div>
            </div>
            <button mat-raised-button (click)="addPackage()">Add Package</button>
        </div>
    </form>
    <button mat-raised-button (click)="search()">Find Rates</button>
</div>
<div *ngIf="rates_grabbed">
    <h4>Carrier Rate</h4>
    <div *ngIf="carrier_rate_error === true">No carrier rate found</div>
    <div *ngIf="carrier_rate_error === false">
        <div>Rate: ${{carrier_rate.rate}}</div>
        <div>Minimum rate: ${{carrier_rate.min_rate}}</div>
        <div>Total Weight: {{carrier_rate.weight}}</div>
        <div>Starting weight for this weight class: {{carrier_rate.weight_start}}lbs</div>
        <div>End weight for this weight class: {{carrier_rate.weight_end ? carrier_rate.weight_end : 'none'}}lbs</div>
        <div>Estimated transit time: {{carrier_rate.transit_time}} days</div>
    </div>
    <h4>Customer Rate</h4>
    <div *ngIf="carrier_rate_error === false">
        <div>Rate: ${{customer_rate.rate}}</div>
        <div>Total Weight: {{customer_rate.weight}}</div>
        <div>Starting weight for this weight class: {{customer_rate.weight_start}}lbs</div>
        <div>End weight for this weight class: {{customer_rate.weight_end ? customer_rate.weight_end : 'none'}}lbs</div>
        <div>Minimum rate: ${{customer_rate.min_rate}}</div>
    </div>
</div>
